import { isAppLanguage } from "./languages";

export const getStoredLanguage = (): string => {
  // Prefer explicit language key if the app stores it separately.
  // (Several components read/write `preferredLanguage` directly.)
  try {
    const explicit = localStorage.getItem("preferredLanguage");
    if (isAppLanguage(explicit)) {
      return explicit;
    }
  } catch {
    // Ignore storage errors
  }

  const user = localStorage.getItem("user");

  if (!user) return "en";

  try {
    const parsedUser = JSON.parse(user);
    const lang = parsedUser?.preferredLanguage;
    return isAppLanguage(lang) ? lang : "en";
  } catch {
    return "en";
  }
};
